import axios from 'axios'

export default {

    get(params) {
        params.categories = Array.isArray(params.categories) ? params.categories.join(',') : null;
        return axios.get('/api/materials', { params });
    },

    /**
     * Find material by id.
     *
     * @param id
     * @returns {AxiosPromise<any>}
     */
    find(id) {
        return axios.get('/api/materials/' + id);
    },

    /**
     * Create material.
     * @param data
     * @param onUploadProgress
     * @returns {AxiosPromise<any>}
     */
    create(data, onUploadProgress = null) {
        // Convert the payload to FormData if submitting a file
        if (data.type === 'file') {
            let formData = new FormData();
            Object.keys(data).forEach(key => formData.append(key, data[key]));
            data = formData;
        }

        const config = {};
        if (onUploadProgress) {
            config.onUploadProgress = onUploadProgress;
        }

        return axios.post('/api/materials', data, config);
    },

    /**
     * Update existing material.
     * @param data
     * @param onUploadProgress
     * @returns {AxiosPromise<any>}
     */
    update(data, onUploadProgress = null) {
        const id = data.id;
        data['_method'] = 'PUT';

        if (data.type === 'file') {
            delete data.uri;
        }

        // Convert the payload to FormData if submitting a file
        if (data.type === 'file' && data.file) {
            let formData = new FormData();
            Object.keys(data).forEach(key => formData.append(key, data[key]));
            data = formData;
        }

        const config = {};
        if (onUploadProgress) {
            config.onUploadProgress = onUploadProgress;
        }

        return axios.post('/api/materials/' + id, data, config);
    },

    /**
     * Delete material.
     * @param id
     * @returns {AxiosPromise}
     */
    delete(id) {
        return axios.delete('/api/materials/' + id);
    },

    /**
     * Request a signed download url and redirect browser to open it.
     * @param material
     */
    download(material) {
        axios.post('/api/materials/' + material.id + '/download')
            .then(response => window.location.href = response.data.url);
    },

    /**
     * Get signed download url for the material.
     * @param materialId
     * @returns {Promise<any>}
     */
    preview(materialId) {
        return axios.post('/api/materials/' + materialId + '/preview')
    },

    /**
     * Add bookmark.
     * @param materialId
     * @returns {AxiosPromise<any>}
     */
    addBookmark(materialId) {
        return axios.post('/api/materials/' + materialId + '/bookmark');
    },

    /**
     * Remove bookmark.
     * @param materialId
     * @returns {AxiosPromise}
     */
    removeBookmark(materialId) {
        return axios.delete('/api/materials/' + materialId + '/bookmark');
    },

    /**
     * Add current user like.
     *
     * @param materialId
     * @returns {AxiosPromise<any>}
     */
    addLike(materialId) {
        return axios.post('/api/materials/' + materialId + '/like');
    },

    /**
     * Remove user like.
     *
     * @param materialId
     * @returns {AxiosPromise}
     */
    removeLike(materialId) {
        return axios.delete('/api/materials/' + materialId + '/like');
    },

    /**
     * Register material view statistic.
     *
     * @param materialId
     * @returns {AxiosPromise<any>}
     */
    addView(materialId) {
        return axios.post('/api/materials/' + materialId + '/view');
    },

    /**
     * Search material.
     *
     * @param q
     * @returns {AxiosPromise<any>}
     */
    search(q) {
        return axios.get('/api/search', { params: { q } });
    },

    /**
     * Get "basic" type for icon mapping.
     * TODO refactor to spreadsheet, text, presentation, etc.
     * @param mime_type
     * @returns {*}
     */
    mimeTypeToBasic(mime_type) {
        if (!mime_type) return null;

        if (mime_type.indexOf('excel') >= 0 || mime_type.indexOf('spreadsheet') >= 0) {
            return 'excel'
        } else if (mime_type.indexOf('rtf') >= 0 || mime_type.indexOf('txt') >= 0 || mime_type.indexOf('word') >= 0 || mime_type.indexOf('text') >= 0 ) {
            return 'word'
        } else if (mime_type.indexOf('presentation') >= 0 || mime_type.indexOf('powerpoint') >= 0) {
            return 'powerpoint'
        } else if (mime_type.indexOf('pdf') >= 0) {
            return 'pdf'
        } else if (mime_type.indexOf('image') >= 0) {
            return 'image'
        } else {
            return 'generic'
        }
    },

    basicType(material) {
        if (!material) return null;

        switch (material.type) {
            case 'link':
                return 'link';

            case 'file':
                return this.mimeTypeToBasic(material.mime_type)

            default:
                return 'generic';
        }
    },

    /**
     * @deprecated
     */
    getBasicTypeFromMimeType: {
        'application/vnd.ms-excel': 'spreadsheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'spreadsheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template': 'spreadsheet',
        'application/vnd.ms-excel.sheet.macroEnabled.12': 'spreadsheet',
        'application/vnd.ms-excel.template.macroEnabled.12': 'spreadsheet',
        'application/vnd.ms-excel.addin.macroEnabled.12': 'spreadsheet',
        'application/vnd.ms-excel.sheet.binary.macroEnabled.12': 'spreadsheet',

        'application/rtf': 'text',
        'text/plain': 'text',
        'application/msword': 'text',
        'application/vnd.oasis.opendocument.text': 'text',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'text',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template': 'text',
        'application/vnd.ms-word.document.macroEnabled.12': 'text',
        'application/vnd.ms-word.template.macroEnabled.12': 'text',

        'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'presentation',

        'application/pdf': 'pdf'

    },
}


// WEBPACK FOOTER //
// ./resources/assets/js/api/materials.js